<script setup>
import { ref } from 'vue'

import { useParticipateStore } from '@/stores/ParticipateStore.js'

const participateStore = useParticipateStore()

const props = defineProps({
    participate: {}
})

const currentName = ref(props.participate.name)

function saveParticipate(id) {
    participateStore.update(id, currentName.value)
}

function deleteParticipate(id) {
    participateStore.remove(id)
}

</script>

<template>
    <div class="row mb-3">
        <div class="col-9">
            <div class="input-group">
                <input type="text" class="form-control" placeholder="Name" aria-label="Name" aria-describedby="Name" v-model="currentName">
                <button class="btn btn-success" type="button" @click="saveParticipate(participate.uuid)">Save</button>
            </div>
        </div>
        <div class="col">
            <button type="button" class="btn btn-danger w-100" :disabled="participate.lock" @click="deleteParticipate(participate.uuid)">Delete</button>
        </div>
    </div>
</template>

<style>
</style>
